import styled, { css } from 'styled-components';
import { applyInputStyles } from '../Input/Input.mixins';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('TextArea/TextArea');

/**
 * Base textarea.
 */
export var TextArea = /*#__PURE__*/styled.textarea.withConfig({
  componentId: "plasma__sc-19ztps1-0"
})(["", " display:block;height:9.375rem;min-height:3.5rem;", ""], applyInputStyles, function (_ref) {
  var resize = _ref.resize;
  return css(["", " ", ""], resize && "resize: ".concat(resize, ";"), resize !== 'both' && resize !== 'horizontal' && 'min-width: 100%;max-width: 100%;');
});